import { Directive, OnInit } from '@angular/core';
import { AbstractCalculatorComponentDirective } from './abstract-calculator-component.directive';

@Directive()
export abstract class AbstractCalculatorComponentEmitsValue extends AbstractCalculatorComponentDirective implements OnInit {
  abstract get controlName(): string;

  get control() {
    return this.formGroup.get(this.controlName);
  }

  ngOnInit(): void {
    this.subs.sink = this.formGroup.controls[this.controlName]?.valueChanges.subscribe((value) => {
      this.manager[this.controlName]?.next(value);
    });
  }
}
